import React, { useEffect, useState } from "react";

import { printElement, printImg } from "../../../master/Print";
import useAppConfig from "../../../config/useAppConfig";
import StudentAdmissionFrom1 from "../../components/StudentAdmissionFrom1";
import StudentAdmissionFrom2 from "../../components/StudentAdmissionFrom2";
import StudentAdmissionFrom3 from "../../components/StudentAdmissionFrom3";
import { SweetAlertShow } from "../../../master/Master";
import { studentDetailsFromDetails } from "../../../../api/StudentDetails";

export default function StudentAdmissionForm({ id }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [selectedBatchId, setSelectedBatchId] = useState("");

  const getStudentDetailsMain = async (student_id) => {
    setLoading(true);

    try {
      const response = await studentDetailsFromDetails(student_id);

      if (response.data.status) {
        const studentData = response?.data?.data;

        setData(studentData);

        // Student ke batches
        const batches = studentData?.student_batch_n_fees ?? [];

        // Default latest batch select
        if (batches.length > 0) {
          setSelectedBatchId(String(batches[batches.length - 1].id));
        }
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      getStudentDetailsMain(id);
    }
  }, [id]);

  const config = useAppConfig("Student", "admission_form");

  // Selected batch
  const selectedBatch = data?.student_batch_n_fees?.find(
    (item) => String(item.id) === String(selectedBatchId)
  );

  // Form ke liye same structure rakhenge
  const formData = {
    ...data,
    student_batch_info: selectedBatch,
  };

  return (
    <div className="card">
      <div className="card-body overflow-auto">
        <div className="row g-4">

          <div className="col-md-4 mb-2">
            <label className="form-label fw-bold">
              Select Batch
            </label>

            <select
              className="form-select"
              value={selectedBatchId}
              onChange={(e) => {
                setSelectedBatchId(e.target.value);
              }}
            >
              <option value="">
                Select Batch
              </option>

              {data?.student_batch_n_fees?.map((batch) => (
                <option
                  key={batch.id}
                  value={batch.id}
                >
                  {batch?.course?.title ?? ""}
                  {" - "}
                  {batch?.session_year?.session ?? ""}
                  {" - "}
                  {batch?.batch?.title ?? ""}
                </option>
              ))}
            </select>
          </div>

          <div className="col text-end mb-1">
            <button
              className="btn btn-info"
              onClick={() => printImg("PrintDiv")}
            >
              <i className="ri-printer-line"></i>
            </button>
          </div>

          <div className="col-12">
            {config?.value === "admission_form_1" ? (
              <StudentAdmissionFrom1 data={formData} />
            ) : config?.value === "admission_form_2" ? (
              <StudentAdmissionFrom2 data={formData} />
            ) : config?.value === "admission_form_3" ? (
              <StudentAdmissionFrom3 data={formData} />
            ) : null}
          </div>

        </div>
      </div>
    </div>
  );
}